import React from "react";
import { Modal } from "antd";

type Props = {
  visible: boolean;
  onCancel: () => void;
};

const handleModalClick = (e: React.MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();
};

export const RatingsInfoModal: React.FC<Props> = ({ visible, onCancel }) => (
  <Modal
    width="50%"
    visible={visible}
    onCancel={(e) => { e.stopPropagation(); e.preventDefault(); onCancel(); }}
    footer={null}
    wrapProps={{ onClick: handleModalClick }}
  >
    <h3>Kako funkcionira ocjenjivanje korisnika?</h3>
    <p>
      Međusobno ocjenjivanje korisnika na Index Oglasima moguće je isključivo
      nakon razmjene poruka putem platforme. Na taj način osiguravamo da se
      ocjene temelje na stvarnoj kupoprodaji, a ne na pretpostavkama ili
      zloupotrebama.
    </p>
    <br />
    <p>
      <strong>Važno je znati:</strong>
    </p>
    <ul>
      <li>
        Ocjenu možete ostaviti samo za oglas oko kojeg ste komunicirali putem
        poruka.
      </li>
      <li>
        Svaka ocjena se ručno provjerava i odobrava od strane administratora
        prije nego što postane javno vidljiva.
      </li>
      <li>
        Ocjene kod kojih nije moguće s dovoljno sigurnosti utvrditi da je do
        kupoprodaje došlo neće biti objavljene.
      </li>
      <li>
        Jednom ostavljena ocjena ne može se naknadno mijenjati, zato je važno da
        bude točna i vjerodostojna.
      </li>
    </ul>
    <p>
      Sustav je osmišljen kako bi štitio i kupce i prodavače te povećao
      povjerenje među korisnicima.
    </p>
    <br />
    <p>
      Cilj ovog sustava je da ocjene budu korisne, informativne i pouzdane,
      kako bi drugi korisnici lakše donijeli odluku o kupnji ili prodaji.
    </p>
  </Modal>
);



// WEBPACK FOOTER //
// ./src/components/RatingsInfoModal/RatingsInfoModal.tsx